// extracted by mini-css-extract-plugin
export var actionButton = "_ie-t";
export var buttonContainer = "_ie-0";
export var buttonContainer2 = "_ie-1";
export var buttonSection = "_ie-2";
export var details = "_ie-3";
export var dropdownItem = "_ie-5";
export var dropdownItemsContainer = "_ie-4";
export var fileInput = "_ie-r";
export var headerButton = "_ie-6";
export var icon = "_ie-7";
export var input = "_ie-8";
export var macroListItem = "_ie-9";
export var mainContent = "_ie-a";
export var microText = "_ie-b";
export var modal = "_ie-w";
export var optionsButton = "_ie-c";
export var paperclip = "_ie-s";
export var pillContent = "_ie-d";
export var preview = "_ie-e";
export var preview2 = "_ie-f";
export var quillEditor = "_ie-q";
export var selectedMacro = "_ie-g";
export var sidebar = "_ie-h";
export var sidebarHeader = "_ie-j";
export var sidebarList = "_ie-i";
export var sidebarListItem = "_ie-k";
export var sidebarSearch = "_ie-l";
export var snoozeDurationWrapper = "_ie-v";
export var statusPillContainer = "_ie-m";
export var tagsContainer = "_ie-n";
export var unselectedMacro = "_ie-o";
export var variable = "_ie-u";
export var wrapper = "_ie-p";